<template>
  <SeoBlogArticle :content="$t('seoArticleRendaExtraComMiglyPro')" :faq="faq">
    <template #afterSections>
      <div class="pro-case-testimonial">
        <p class="pro-case-quote">&ldquo;{{ $t('home.pricingTestimonialQuote') }}&rdquo;</p>
        <div class="pro-case-author">
          <picture>
            <source srcset="/images/person/001-88.webp" type="image/webp"/>
            <img src="/images/person/001-88.jpg" alt="Luis Eduardo" loading="lazy" width="44" height="44" class="pro-case-avatar"/>
          </picture>
          <div>
            <div class="pro-case-name">Luis Eduardo</div>
            <div class="pro-case-role">{{ $t('home.roleDeveloper') }}</div>
            <a href="https://www.instagram.com/lss.duda/" target="_blank" rel="noopener" class="pro-case-social">@lss.duda</a>
          </div>
        </div>
        <a href="/#planos" class="pro-case-cta">{{ $t('plansAndPrices') }}</a>
      </div>
    </template>
  </SeoBlogArticle>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
import faq from "../../../../public/seo-faq/renda-extra-com-migly-pro.json";
export default {
  name: 'ArticleRendaExtraComMiglyPro',
  components: { SeoBlogArticle },
  data: () => ({ faq: faq.items }),
}
</script>
<style scoped>
.pro-case-testimonial {
  background: #FFFFFF;
  border-radius: 1.25rem;
  box-shadow: 0 8px 20px rgba(16,24,39,0.05);
  padding: 1.75rem;
  font-family: 'Montserrat', sans-serif;
}
.pro-case-quote {
  font-size: 1.1rem;
  font-style: italic;
  color: #101827;
  line-height: 1.6;
  margin: 0 0 1.25rem;
}
.pro-case-author {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}
.pro-case-avatar {
  border-radius: 50%;
  object-fit: cover;
}
.pro-case-name {
  font-weight: 800;
  color: #101827;
  font-size: 0.95rem;
}
.pro-case-role {
  color: #5B6472;
  font-size: 0.82rem;
}
.pro-case-social {
  color: #0277BD;
  font-weight: 700;
  font-size: 0.82rem;
  text-decoration: none;
}
.pro-case-social:hover {
  text-decoration: underline;
}
.pro-case-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0277BD;
  color: #FFFFFF;
  font-weight: 700;
  font-size: 0.9rem;
  text-decoration: none;
  border-radius: 999px;
  padding: 0.75rem 1.5rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.pro-case-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2,119,189,0.3);
}
</style>
